import imgBg from './assets/illustration-empty-bg.svg'
import imgDoc from './assets/illustration-empty-doc.svg'
import imgBadge from './assets/illustration-empty-badge.svg'

export function IllustrationEmpty({ className }: { className?: string }) {
	return (
		<div className={`relative h-[166px] w-[150px] shrink-0 ${className ?? ''}`}>
			{/* Background circle */}
			<div className="absolute inset-[4.82%_0_0_0]">
				<div className="absolute inset-[0_0_-1.9%_0]">
					<img alt="" className="block size-full max-w-none" src={imgBg} />
				</div>
			</div>
			{/* Document */}
			<div className="absolute inset-[0_18%_75.9%_18%]">
				<img alt="" className="block size-full max-w-none" src={imgDoc} />
			</div>
			{/* Badge */}
			<div className="absolute inset-[6.63%_42.67%_81.93%_24%]">
				<img alt="" className="absolute block size-full max-w-none" src={imgBadge} />
			</div>
		</div>
	)
}
